// extracted by mini-css-extract-plugin
export default {"tooltip":"HR-z","arrow":"IR-z"};